import React from "react";
import ScrollElement from "./scroll-element";

const upcomingEvents = [
	// {
	// 	id: 1,
	// 	name: "Annual School Sports",
	// 	date: "2025-02-26",
	// },

	// {
	// 	id: 2,
	// 	name: "World No Tobacco Day",
	// 	date: "2025-05-31",
	// },
	// {
	// 	id: 3,
	// 	name: "World Environment Day",
	// 	date: "2025-06-05",
	// }, 
	// {
	// 	id: 4,
	// 	name: "Literary Day",
	// 	date: "2025-07-10",
	// },
	// {
	// 	id: 5,
	// 	name: "Teachers' Day",
	// 	date: "2025-09-05",
	// },
	{
		id: 6,
		name: "National Education Day",
		date: "2025-11-11",
	},
	{
		id: 7,
		name: "Children's Day",
		date: "2025-11-14",
	},
	{
		id: 8,
		name: "Constitution Day",
		date: "2025-11-26",
	},
	// Add more events here
];

// Helper function to format date as dd/mm/yy
const formatDate = (dateString) => {
	const date = new Date(dateString);
	return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "numeric",
		year: "2-digit",
	});
};

const UpcomingEvents = () => {
	return (
		<div className="text-center m-auto md:w-2/3 px-4">
			<div className="font-bold text-theme text-3xl mb-7" style={{ textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)" }}>Upcoming Events</div>
			<ul className="space-y-4 overflow-hidden p-10">
				{upcomingEvents.map((event, index) => (
					<ScrollElement
						direction={index % 2 === 0 ? 'left' : 'right'}
						viewport={{ amount: 0.5, margin: '0px 0px 0px 0px' }}
						key={event.id}
					>
						<li
							className="flex items-center justify-between bg-white p-4 rounded-lg "
							style={{
								boxShadow: "0px 4px 11px 0px"
							}}
						>
							<span className="font-medium text-lg">
								{event.name}
							</span>
							<span className="text-gray-600">
								{formatDate(event.date)}
							</span>
						</li>
					</ScrollElement>
				))}
			</ul>
		</div>
	);
};

export default UpcomingEvents;
